module.exports = __webpack_public_path__ + "img/chengyun44.617bc2a0.png";